import React, { useEffect, useState } from 'react'
import Navbar from '../componenets/Navbar'
import bgImage from '../Images/Rectangle1.png'
import Footer from '../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'
import WOW from "wowjs";
import "animate.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);

  return (
    <div>
      <Navbar />


      <section
        className="about_who-we-are"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="about_who-we-are-content">
          <p className="about_tag">Contact Us</p>
          <h1>Get in Touch with Us.</h1>
        </div>
      </section>

      <section className="services_detail_texts addresText wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <h3>Address</h3>
        <p>Km 16, Port Harcourt-Aba Expressway Boskel Road, Port Harcourt, Nigeria.</p>
      </section>

    <div className=''>
      <hr className='hr_line' />
    </div>


      <section className="services_detail_texts wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <div className="flec_contact">
          <div className="flexponecontact">
            <h3>Phone Number</h3>
            <p>+2348062723480</p></div>
          <div className="flexptwocontact">
            <h3>Email</h3>
            <p>info@wellcleanoilfieldservices</p>
          </div>
        </div>
      </section>


      <hr className='hr_line' />

      <section className="border_bottom_divs wow animate__animated animate__fadeInUp" >
        <h2>We are ready to help you with any inquiries you may have.</h2>
      </section>



      <div className="form">
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="FULL NAME"
            value={formData.fullName}
            className="wow animate__animated animate__fadeInUp" data-wow-delay="0.2s"
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            className="wow animate__animated animate__fadeInUp" data-wow-delay="0.4s"
            placeholder="CONTACT EMAIL"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="MESSAGE"
            className="wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"
            value={formData.message}
            onChange={handleChange}
            required
          />

          <div className='contact_btn_for_sumbit wow animate__animated animate__fadeInUp' data-wow-delay="0.6s">
            <div className="contactBtn">
              <button className="contact-btn">Submit</button>
              <button className="contact-btn">
                <FiArrowUpRight size={24} />
              </button>
            </div>
          </div>
        </form>
      </div>


      <Footer />

    </div>
  )
}

export default Contact